import axios from 'axios';

class UrlLoaderService {
    constructor(store) {
        this.$store = store;
        this.axiosInstance = axios.create({
            baseURL: 'http://localhost:3000/api',
            timeout: 10000,
        });

        this.axiosInstance.interceptors.request.use(
            (config) => {
                const token = localStorage.getItem('10-4-Token');
                if (token) {
                    config.headers['Authorization'] = `Bearer ${token}`;
                }
                return config;
            },
            (error) => {
                return Promise.reject(error);
            }
        );

        this.axiosInstance.interceptors.response.use(
            (response) => response,
            (error) => {
                if (error.response) {
                    const { status } = error.response;

                    switch (status) {
                        case 400:
                            console.error('Bad Request: ', error.response.data);
                            break;
                        case 401:
                            console.error('Unauthorized: ', error.response.data);
                            this.$store.dispatch('logout');
                            break;
                        case 403:
                            console.error('Forbidden: ', error.response.data);
                            break;
                        case 404:
                            console.error('Not Found: ', error.response.data);
                            break;
                        case 500:
                            console.error('Internal Server Error: ', error.response.data);
                            break;
                        default:
                            console.error('Unexpected Error: ', error.response.data);
                            break;
                    }
                } else if (error.request) {
                    console.error('No response received: ', error.request);
                } else {
                    console.error('Error occurred: ', error.message);
                }

                // Throw the error to be caught in the component
                return Promise.reject(error);
            }
        );
    }

    // Function to make GET requests
    get(url, params = {}) {
        return this.axiosInstance.get(url, { params });
    }

    // Function to make POST requests
    post(url, data) {
        return this.axiosInstance.post(url, data);
    }

    // Function to make PUT requests
    put(url, data) {
        return this.axiosInstance.put(url, data);
    }

    // Function to make DELETE requests
    delete(url) {
        return this.axiosInstance.delete(url);
    }
}
import store from '../store'; // Adjust the path to your Vuex store
export default new UrlLoaderService(store);
